import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		flex: 1,
	},
	notFound: {
		display: 'block',
		margin: '110px auto 0',
	},
});
